import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { formatScrumText } from '../../utils/textFormatter';

const FormattedAnswer = ({ text, sx = {} }) => {
  const formattedParagraphs = formatScrumText(text);
  
  return (
    <Box sx={{ ...sx }}>
      {formattedParagraphs.map((paragraph, index) => {
        // Different styling based on paragraph type
        const paragraphSx = {
          mb: 2,
          fontSize: { xs: '0.9rem', md: '1rem' },
          ...(paragraph.type === 'list-item' && {
            pl: 2,
          }),
          ...(paragraph.type === 'bullet-point' && {
            pl: 2,
          }),
        };
        
        return (
          <Typography 
            key={index} 
            paragraph 
            sx={paragraphSx}
            dangerouslySetInnerHTML={{ __html: paragraph.text }}
          />
        );
      })}
    </Box>
  );
};

export default FormattedAnswer;